<template>
  <div id="app" class="anime-tech-theme">
    <router-view />
  </div>
</template>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }

:root {
  --bg-primary: #080b14;
  --bg-secondary: #0f1628;
  --bg-elevated: rgba(18, 27, 48, .92);
  --bg-card: rgba(15, 23, 42, .86);
  --bg-card-hover: rgba(24, 36, 64, .96);
  --bg-input: rgba(7, 12, 24, .74);
  --border-color: rgba(124, 242, 255, .16);
  --border-strong: rgba(124, 242, 255, .32);
  --text-primary: #eef7ff;
  --text-secondary: #a9b8d5;
  --text-muted: #71809d;
  --accent-cyan: #36e4ff;
  --accent-blue: #4f8cff;
  --accent-violet: #8d7cff;
  --accent-green: #58f2a9;
  --accent-yellow: #ffd166;
  --accent-red: #ff5573;
  --shadow-glow: 0 18px 46px rgba(54, 228, 255, .12);
}

body {
  font-family: Inter, "PingFang SC", "Microsoft YaHei", system-ui, sans-serif;
  background: var(--bg-primary);
  color: var(--text-primary);
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
}

::-webkit-scrollbar { width: 8px; height: 8px; }
::-webkit-scrollbar-track { background: rgba(255,255,255,.02); }
::-webkit-scrollbar-thumb { background: rgba(54,228,255,.28); border-radius: 8px; }

.anime-tech-theme .el-card {
  background: var(--bg-card) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 10px !important;
  box-shadow: var(--shadow-glow) !important;
  color: var(--text-primary) !important;
  backdrop-filter: blur(16px);
}
.anime-tech-theme .el-card__header {
  border-bottom-color: rgba(124,242,255,.12) !important;
}
.anime-tech-theme .el-input__wrapper,
.anime-tech-theme .el-textarea__inner,
.anime-tech-theme .el-select__wrapper {
  background: var(--bg-input) !important;
  border: 1px solid rgba(124,242,255,.18) !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  color: var(--text-primary) !important;
}
.anime-tech-theme .el-input__inner,
.anime-tech-theme .el-textarea__inner,
.anime-tech-theme .el-select__placeholder,
.anime-tech-theme .el-select__selected-item {
  color: var(--text-primary) !important;
}
.anime-tech-theme .el-input__wrapper.is-focus,
.anime-tech-theme .el-select__wrapper.is-focused {
  border-color: var(--accent-cyan) !important;
  box-shadow: 0 0 0 3px rgba(54,228,255,.12) !important;
}
.anime-tech-theme .el-form-item__label,
.anime-tech-theme .el-checkbox,
.anime-tech-theme .el-radio,
.anime-tech-theme .el-radio-button__inner {
  color: var(--text-secondary) !important;
}
.anime-tech-theme .el-button {
  border-radius: 8px !important;
  font-weight: 800;
}
.anime-tech-theme .el-button--primary {
  border: 0 !important;
  color: #04111d !important;
  background: linear-gradient(135deg, var(--accent-cyan), var(--accent-green)) !important;
  box-shadow: 0 12px 24px rgba(54,228,255,.22) !important;
}
.anime-tech-theme .el-button--success {
  border: 0 !important;
  color: #04111d !important;
  background: linear-gradient(135deg, var(--accent-green), #9dffce) !important;
}
.anime-tech-theme .el-button--warning {
  border: 0 !important;
  color: #1a1200 !important;
  background: linear-gradient(135deg, var(--accent-yellow), #ffb45f) !important;
}
.anime-tech-theme .el-table {
  background: transparent !important;
  color: var(--text-primary) !important;
}
.anime-tech-theme .el-table th.el-table__cell {
  background: rgba(12, 19, 36, .96) !important;
  color: var(--text-secondary) !important;
}
.anime-tech-theme .el-table tr,
.anime-tech-theme .el-table td.el-table__cell {
  background: transparent !important;
  border-bottom-color: rgba(124,242,255,.08) !important;
}
.anime-tech-theme .el-table__row:hover td.el-table__cell {
  background: rgba(54,228,255,.06) !important;
}
.anime-tech-theme .el-dialog {
  border-radius: 12px !important;
  background: rgba(10,16,30,.98) !important;
  border: 1px solid var(--border-strong) !important;
  color: var(--text-primary) !important;
}
.anime-tech-theme .el-dialog__title,
.anime-tech-theme .el-dialog__body {
  color: var(--text-primary) !important;
}
.anime-tech-theme .el-empty__description p { color: var(--text-muted) !important; }

@media (max-width: 720px) {
  body { font-size: 14px; }
  .anime-tech-theme .el-row { display: block !important; margin-left: 0 !important; margin-right: 0 !important; }
  .anime-tech-theme .el-col {
    max-width: 100% !important;
    flex: 0 0 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .anime-tech-theme .el-card { border-radius: 9px !important; }
  .anime-tech-theme .el-card__body { padding: 14px !important; }
  .anime-tech-theme .el-dialog {
    width: calc(100vw - 18px) !important;
    margin: 0 auto !important;
    max-height: 92vh;
    overflow: auto;
  }
  .anime-tech-theme .el-dialog__body { padding: 12px 14px !important; }
  .anime-tech-theme .el-button { min-height: 36px; }
  .anime-tech-theme .el-input-number { width: 100% !important; }
  .anime-tech-theme .el-date-editor { width: 100% !important; }
  .anime-tech-theme .el-table { font-size: 12px; }
}
</style>
